const SOUND_FILES = {
  type: "type.wav",
  wrong: "wrong.wav",
  complete: "complete.wav",
  slow: "slow.wav",
  freeze: "freeze.wav",
  heart: "heart.wav",
  bomb: "bomb.wav",
  danger: "danger.wav",
  wave: "wave.wav",
  gameover: "gameover.wav",
};

const POOL_SIZE = 4;
const STORAGE_KEY = "writé:audio";

const defaultPrefs = { enabled: true, volume: 0.6 };

let prefs = defaultPrefs;
try {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw) prefs = { ...defaultPrefs, ...JSON.parse(raw) };
} catch (e) {}

const pools = {};
let initialized = false;

const init = () => {
  if (initialized) return;
  initialized = true;
  Object.entries(SOUND_FILES).forEach(([name, file]) => {
    pools[name] = Array.from({ length: POOL_SIZE }, () => {
      const a = new Audio(`${process.env.PUBLIC_URL || ""}/sounds/${file}`);
      a.preload = "auto";
      return a;
    });
  });
};

let cursors = {};

export const play = (name) => {
  if (!prefs.enabled) return;
  if (!pools[name]) {
    init();
    if (!pools[name]) return;
  }
  const pool = pools[name];
  const idx = (cursors[name] || 0) % pool.length;
  cursors[name] = idx + 1;
  const audio = pool[idx];
  audio.volume = prefs.volume;
  audio.currentTime = 0;
  audio.play().catch(() => {});
};

export const setEnabled = (enabled) => {
  prefs = { ...prefs, enabled };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  } catch (e) {}
};

export const setVolume = (volume) => {
  prefs = { ...prefs, volume: Math.max(0, Math.min(1, volume)) };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  } catch (e) {}
};

export const getPrefs = () => ({ ...prefs });

export const preload = () => init();
